import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PassObjective } from '../types/pass'

import { api } from '@/shared/services/api'

// Resgate manual da recompensa (coin) de um objetivo do passe — igual ao finish
// da missão: o aluno clica para receber. Invalida a lista para refletir o novo
// status (delivered).
export function usePassObjectiveClaim() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (objective: PassObjective) => {
      await api.post(`/user/pass_objectives/${objective.id}/claim`)
      // Mesmo motivo do resgate de tier: a invalidação abaixo faz
      // `collapsedObjectives` avançar para o próximo objetivo do grupo, então
      // o resgatado precisa viajar junto para a revelação.
      return objective
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/user/passes'] })
      queryClient.invalidateQueries({ queryKey: ['/user/gamification/progress'] })
    }
  })
}
